module.exports = __webpack_public_path__ + "img/be0a87a.jpg";